/**
 * Generated runtime TestId mirror for frontend/src/components/types/TypeValuesView.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const TypeValuesViewTestIds = {
  colActions: "col-actions",
  colActive: "col-active",
  colCode: "col-code",
  colIcon: "col-icon",
  colUsage: "col-usage",
  typeValuesNoResults: "type-values-no-results",
  typeValuesSearch: "type-values-search",
  group: (key: string) => `group-${key}`,
  groupPrefix: () => "group-" as TestIdPrefix,
  groupCount: (key: string) => `group-count-${key}`,
  groupCountPrefix: () => "group-count-" as TestIdPrefix,
  groupLabel: (key: string) => `group-label-${key}`,
  groupLabelPrefix: () => "group-label-" as TestIdPrefix
} as const;
